module.exports = __webpack_public_path__ + "img/SKMJ_train5.842b976a.jpg";